import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      settings: {
        general_settings: {
          tabs: {
            click_domains: {
              tab_name: 'TAB_NAME',
              add_domain_button: 'ADD_DOMAIN',
              form: {
                default_domain: 'FORM.DEFAULT_DOMAIN',
              },
              add_domain: {
                header: 'ADD_DOMAIN.HEADER',
                save: 'ADD_DOMAIN.SAVE',
                back: 'ADD_DOMAIN.BACK',
                form: {
                  domain: 'ADD_DOMAIN.FORM.DOMAIN',
                },
              },
            },
          },
        },
      },
    },
  }));
}
